export const LARGE_NUMBERS = [
  {
    size: 1000000000000,
    longDesc: "trillion",
    shortDesc: "T",
  },
  {
    size: 1000000000,
    longDesc: "billion",
    shortDesc: "B",
  },
  {
    size: 1000000,
    longDesc: "million",
    shortDesc: "M",
  },
  {
    size: 1000,
    longDesc: "thousand",
    shortDesc: "K",
  },
]